import type { FilterPreset } from '../../shared/hooks/useFilterPresets';

/**
 * Pre-defined filter presets for the Grades (Product Types) page.
 *
 * Each preset maps to a named {@link FilterPreset} that the user can apply
 * with a single click via the preset UI.
 */
export const GRADE_PRESETS: FilterPreset[] = [
  {
    id: 'grade_all',
    label: 'All Product Types',
    description: 'Show all product types with no filters applied',
    query: {
      groupOperator: 'AND',
      filterGroups: [],
    },
  },
];
